import useSWR from "swr";
import { WorkspaceModel } from "lib/types/workspaces/WorkspaceModel";
import { endpoints } from "lib/actions/endpoints/endpoints";
import { fetcher } from "lib/actions/fetcher";

export const useWorkspaces = () => {
  const {
    data: workspaces,
    error,
    mutate,
  } = useSWR<WorkspaceModel[]>(endpoints.workspaces, fetcher);

  return {
    workspaces,
    isLoading: !workspaces && !error,
    hasError: !!error,
    mutate,
  };
};
